'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLinkedCamera = function MdLinkedCamera(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.6 10c1.9 0 3.4 1.5 3.4 3.4h2.2c0-3.1-2.5-5.6-5.6-5.6v2.2z m-6.6 21.6c4.6 0 8.4-3.6 8.4-8.2s-3.8-8.4-8.4-8.4-8.4 3.8-8.4 8.4 3.8 8.2 8.4 8.2z m8.4-16.6h8.2v18.4c0 1.8-1.4 3.2-3.2 3.2h-26.8c-1.8 0-3.2-1.4-3.2-3.2v-20c0-1.8 1.4-3.4 3.2-3.4h5.4l3-3.4h10v5c1.9 0 3.4 1.5 3.4 3.4z m-1.8-9.5v-2.1c5.6 0 10 4.4 10 10h-2.1c0-4.3-3.6-7.9-7.9-7.9z m-11.9 17.9c0-3 2.3-5.4 5.3-5.4s5.3 2.4 5.3 5.4-2.3 5.3-5.3 5.3-5.3-2.4-5.3-5.3z' })
        )
    );
};

exports.default = MdLinkedCamera;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/linked-camera.js
// module id = 3489
// module chunks = 168707334958949